/**
 * @namespace Stores
 * @category Stores
 * @module geocoding
 * */

const createState = () => ({
  isSelectorVisible: true,
})

export default {
  namespaced: true,
  state: createState(),
}
